import BaseDataObject from './BaseDataObject';

export default class StakeHorsesWithoutMarks extends BaseDataObject {
  isEmpty() {
    return this.getMissingHorsesLegNumbers().length === 0;
  }

  getMissingHorsesLegNumbers() {
    const legNumbers = [];
    if (this.data.missingHorsesLegs) {
      for (const legNr in this.data.missingHorsesLegs) {
        legNumbers.push(legNr);
      }
    }
    return legNumbers;
  }

  getMissingHorsesLegStartNumbers(legNr) {
    let legNumbers;

    if (this.data.missingHorsesLegs) {
      legNumbers = this.data.missingHorsesLegs[legNr];
    }

    if (!Array.isArray(legNumbers)) {
      legNumbers = [];
    }

    return legNumbers;
  }
}
